// export const domain = process.env.VUE_APP_DOMAIN;
// export const domainV2 = process.env.VUE_APP_DOMAIN_V2;
// export const imageDomain = process.env.VUE_APP_IMG_DOMAIN;

// // local
// export const domain = "http://127.0.0.1:8001/api/";
// export const domainV2 = "http://127.0.0.1:8001/api2/";
// export const imageDomain = "http://127.0.0.1:8001/storage/";

// // server test
// export const domain = "https://acaapi.ksta.co/api/";
// export const domainV2 = "http://acaapi.ksta.co/api2/";
// export const imageDomain = "https://acaapi.ksta.co/storage/";

// Server Prod
export const domain = "https://elearningapi.ordpmk.com/api/";
export const domainV2 = "https://elearningapi.ordpmk.com/api2";
export const imageDomain = "https://elearningapi.ordpmk.com/storage/";
